import { render, staticRenderFns } from "./FieldAttachments.vue?vue&type=template&id=156d6e7a"
import script from "./FieldAttachments.vue?vue&type=script&lang=js"
export * from "./FieldAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports